
import { catchError, map } from 'rxjs/operators';

import { Headers } from './headers';
import {
    HttpClient,
    HttpHeaders,
    HttpResponse,
    HttpErrorResponse
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
    IHttp,
    IResponseOptionsArgs,
    IRequestOptionsBase,
    IRequestOptionsJson,
    IRequestOptionsArrayBuffer,
    IRequestOptionsText,
    IRequestOptionsBlob,
    IRequestOptionsArgs,
    ResponseTypeNames,
    ResponseType
} from './interfaces';
import { Observable } from 'rxjs';
import { Response } from './response';

import { ResponseOptions } from './responseOptions';
import shellapi from 'a365-shell-api';

@Injectable({
    providedIn: 'root'
})
export class Http implements IHttp {
    public static readonly className = 'Http';
    private currentClient: HttpClient;

    constructor(currentClient: HttpClient) {
        this.currentClient = currentClient;
    }

    public request(url: string, options?: IRequestOptionsArgs): Observable<Response> {
        const method = this._parseOptionsRequestMethod(options);
        const newOptions = this._parseOptionsToNewOptions(options);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        let response: Observable<HttpResponse<any>>;
        switch (newOptions.responseType) {
            case ResponseTypeNames.JSON:
                const newOptionsJson: IRequestOptionsJson = newOptions as IRequestOptionsJson;
                response = this.currentClient.request(method, url, newOptionsJson);
                break;
            case ResponseTypeNames.ARRAYBUFFER:
                const newOptionsArrayBuffer: IRequestOptionsArrayBuffer = newOptions as IRequestOptionsArrayBuffer;
                response = this.currentClient.request(method, url, newOptionsArrayBuffer);
                break;
            case ResponseTypeNames.TEXT:
                const newOptionsText: IRequestOptionsText = newOptions as IRequestOptionsText;
                response = this.currentClient.request(method, url, newOptionsText);
                break;
            case ResponseTypeNames.BLOB:
                const newOptionsBlob: IRequestOptionsBlob = newOptions as IRequestOptionsBlob;
                response = this.currentClient.request(method, url, newOptionsBlob);
                break;
            default:
                this.throwInternalError();
                return null;
        }
        return this._mapToADFResponseObservable(response);
    }

    // eslint-disable-next-line
    public get(url: string, options?: IRequestOptionsArgs): Observable<Response> {
        const newOptions = this._parseOptionsToNewOptions(options);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        let response: Observable<HttpResponse<any>>;
        switch (newOptions.responseType) {
            case ResponseTypeNames.JSON:
                const newOptionsJson: IRequestOptionsJson = newOptions as IRequestOptionsJson;
                response = this.currentClient.get(url, newOptionsJson);
                break;
            case ResponseTypeNames.ARRAYBUFFER:
                const newOptionsArrayBuffer: IRequestOptionsArrayBuffer = newOptions as IRequestOptionsArrayBuffer;
                response = this.currentClient.get(url, newOptionsArrayBuffer);
                break;
            case ResponseTypeNames.TEXT:
                const newOptionsText: IRequestOptionsText = newOptions as IRequestOptionsText;
                response = this.currentClient.get(url, newOptionsText);
                break;
            case ResponseTypeNames.BLOB:
                const newOptionsBlob: IRequestOptionsBlob = newOptions as IRequestOptionsBlob;
                response = this.currentClient.get(url, newOptionsBlob);
                break;
            default:
                this.throwInternalError();
                return null;
        }
        return this._mapToADFResponseObservable(response);
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    public post(url: string, body: any, options?: IRequestOptionsArgs): Observable<Response> {
        const newOptions = this._parseOptionsToNewOptions(options);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        let response: Observable<HttpResponse<any>>;
        switch (newOptions.responseType) {
            case ResponseTypeNames.JSON:
                const newOptionsJson: IRequestOptionsJson = newOptions as IRequestOptionsJson;
                response = this.currentClient.post(url, body, newOptionsJson);
                break;
            case ResponseTypeNames.ARRAYBUFFER:
                const newOptionsArrayBuffer: IRequestOptionsArrayBuffer = newOptions as IRequestOptionsArrayBuffer;
                response = this.currentClient.post(url, body, newOptionsArrayBuffer);
                break;
            case ResponseTypeNames.TEXT:
                const newOptionsText: IRequestOptionsText = newOptions as IRequestOptionsText;
                response = this.currentClient.post(url, body, newOptionsText);
                break;
            case ResponseTypeNames.BLOB:
                const newOptionsBlob: IRequestOptionsBlob = newOptions as IRequestOptionsBlob;
                response = this.currentClient.post(url, body, newOptionsBlob);
                break;
            default:
                this.throwInternalError();
                return null;
        }
        return this._mapToADFResponseObservable(response);
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    public put(url: string, body: any, options?: IRequestOptionsArgs): Observable<Response> {
        const newOptions = this._parseOptionsToNewOptions(options);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        let response: Observable<HttpResponse<any>>;
        switch (newOptions.responseType) {
            case ResponseTypeNames.JSON:
                const newOptionsJson: IRequestOptionsJson = newOptions as IRequestOptionsJson;
                response = this.currentClient.put(url, body, newOptionsJson);
                break;
            case ResponseTypeNames.ARRAYBUFFER:
                const newOptionsArrayBuffer: IRequestOptionsArrayBuffer = newOptions as IRequestOptionsArrayBuffer;
                response = this.currentClient.put(url, body, newOptionsArrayBuffer);
                break;
            case ResponseTypeNames.TEXT:
                const newOptionsText: IRequestOptionsText = newOptions as IRequestOptionsText;
                response = this.currentClient.put(url, body, newOptionsText);
                break;
            case ResponseTypeNames.BLOB:
                const newOptionsBlob: IRequestOptionsBlob = newOptions as IRequestOptionsBlob;
                response = this.currentClient.put(url, body, newOptionsBlob);
                break;
            default:
                this.throwInternalError();
                return null;
        }
        return this._mapToADFResponseObservable(response);
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    public patch(url: string, body: any, options?: IRequestOptionsArgs): Observable<Response> {
        const newOptions = this._parseOptionsToNewOptions(options);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        let response: Observable<HttpResponse<any>>;
        switch (newOptions.responseType) {
            case ResponseTypeNames.JSON:
                const newOptionsJson: IRequestOptionsJson = newOptions as IRequestOptionsJson;
                response = this.currentClient.patch(url, body, newOptionsJson);
                break;
            case ResponseTypeNames.ARRAYBUFFER:
                const newOptionsArrayBuffer: IRequestOptionsArrayBuffer = newOptions as IRequestOptionsArrayBuffer;
                response = this.currentClient.patch(url, body, newOptionsArrayBuffer);
                break;
            case ResponseTypeNames.TEXT:
                const newOptionsText: IRequestOptionsText = newOptions as IRequestOptionsText;
                response = this.currentClient.patch(url, body, newOptionsText);
                break;
            case ResponseTypeNames.BLOB:
                const newOptionsBlob: IRequestOptionsBlob = newOptions as IRequestOptionsBlob;
                response = this.currentClient.patch(url, body, newOptionsBlob);
                break;
            default:
                this.throwInternalError();
                return null;
        }
        return this._mapToADFResponseObservable(response);
    }

    // eslint-disable-next-line
    public delete(url: string, options?: IRequestOptionsArgs): Observable<Response> {
        const newOptions = this._parseOptionsToNewOptions(options);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        let response: Observable<HttpResponse<any>>;
        switch (newOptions.responseType) {
            case ResponseTypeNames.JSON:
                const newOptionsJson: IRequestOptionsJson = newOptions as IRequestOptionsJson;
                response = this.currentClient.delete(url, newOptionsJson);
                break;
            case ResponseTypeNames.ARRAYBUFFER:
                const newOptionsArrayBuffer: IRequestOptionsArrayBuffer = newOptions as IRequestOptionsArrayBuffer;
                response = this.currentClient.delete(url, newOptionsArrayBuffer);
                break;
            case ResponseTypeNames.TEXT:
                const newOptionsText: IRequestOptionsText = newOptions as IRequestOptionsText;
                response = this.currentClient.delete(url, newOptionsText);
                break;
            case ResponseTypeNames.BLOB:
                const newOptionsBlob: IRequestOptionsBlob = newOptions as IRequestOptionsBlob;
                response = this.currentClient.delete(url, newOptionsBlob);
                break;
            default:
                this.throwInternalError();
                return null;
        }
        return this._mapToADFResponseObservable(response);
    }

    private _parseOptionsRequestMethod(options?: IRequestOptionsArgs): string {
        if (!options || !options.method) {
            return 'GET';
        }
        if (typeof options.method === 'string') {
            return options.method.toUpperCase();
        }
        const optionsArray = ['GET', 'POST', 'PUT', 'DELETE', 'OPTIONS', 'HEAD', 'PATCH'];
        return optionsArray[options.method];
    }

    private _parseOptionsToNewOptions(options?: IRequestOptionsArgs): IRequestOptionsBase {
        if (!options) {
            return {
                observe: 'response' as 'response',
                responseType: 'json' as 'json'
            };
        }
        const headers: HttpHeaders = this._headerToNewHttpHeaders(options.headers);
        const responseTypeArray = [
            'text' as 'text',
            'json' as 'json',
            'arraybuffer' as 'arraybuffer',
            'blob' as 'blob'
        ];
        const responseType = (!options.responseType)
            ? responseTypeArray[0]
            : (typeof options.responseType === 'string')
                ? options.responseType
                : responseTypeArray[options.responseType];

        const result: IRequestOptionsBase = {
            params: options.params,
            headers,
            withCredentials: options.withCredentials,
            responseType,
            observe: 'response' as 'response',
            body: options.body
        };
        return result;
    }

    private _headerToNewHttpHeaders(oldHeaders: shellapi.http.IHeaders): HttpHeaders {
        if (!oldHeaders) {
            return new HttpHeaders();
        }
        const headersMap: { [key: string]: string } = {};
        oldHeaders.keys().forEach((key) => {
            const headerVal = oldHeaders.get(key);
            if (headerVal != null) {
                headersMap[key] = headerVal;
            }
        });
        return new HttpHeaders(headersMap);
    }

    private _newHttpHeadersToOldHeaders(newHeaders: HttpHeaders): shellapi.http.IHeaders {
        if (!newHeaders) {
            return new Headers();
        }
        const headersMap: { [key: string]: string } = {};
        newHeaders.keys().forEach((key) => {
            const headerVal = newHeaders.get(key);
            if (headerVal != null) {
                headersMap[key] = headerVal;
            }
        });
        return new Headers(headersMap);
    }

    // eslint-disable-next-line
    private _changeToADFResponse(response: HttpResponse<string | Blob | Object | ArrayBuffer>): Response {
        if (!response) {
            return new Response(new ResponseOptions());
        }
        const responseOptionArgs = {
            body: response.body,
            status: response.status,
            statusText: response.statusText,
            headers: this._newHttpHeadersToOldHeaders(response.headers),
            url: response.url
        };
        return new Response(new ResponseOptions(responseOptionArgs));
    }

    private throwInternalError(): void {
        throw new Error(stringResources.InternalHttpClientError);
    }

    private _changeToADFErrorResponse(errorResponse: HttpErrorResponse): Response {
        if (!errorResponse) {
            return new Response(new ResponseOptions());
        }
        const responseOptionArgs: IResponseOptionsArgs = {
            body: errorResponse.error,
            status: errorResponse.status,
            statusText: errorResponse.statusText,
            headers: this._newHttpHeadersToOldHeaders(errorResponse.headers),
            url: errorResponse.url,
            type: ResponseType.Error
        };
        return new Response(new ResponseOptions(responseOptionArgs));
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    private _handleException(res: any): void {
        if (res instanceof HttpErrorResponse) {
            throw this._changeToADFErrorResponse(res);
        }
        throw res;
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    private _mapToADFResponseObservable(res: Observable<HttpResponse<any>>): Observable<Response> {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const mappedResponse = res.pipe(map<HttpResponse<any>, Response>(this._changeToADFResponse.bind(this)));
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return mappedResponse.pipe(catchError<Response, Observable<Response>>(this._handleException.bind(this)));
    }
}
